import React from "react";
import girl from "../assets/imgs/home.png";
import hot from "../assets/imgs/hot.png";
import premium from "../assets/imgs/premium.png";
import { Link } from "react-router-dom";

const packages = [
  {
    title: "GÓI MCA NGÀY",
    hot: true,
    desc: ["Sử dụng toàn bộ tính năng của dịch vụ"],
    price: "500 đ/ngày",
    action: "DÙNG NGAY",
  },
  {
    title: "GÓI MCA TUẦN",
    hot: true,
    desc: ["Sử dụng toàn bộ tính năng của dịch vụ"],
    price: "2.000 đ/tuần",
    action: "CHỌN GÓI NÀY",
  },

  // 👉 ẢNH – index = 2
  {
    type: "image",
  },

  {
    title: "GÓI MCA PLUS",
    hot: true,
    desc: ["Sử dụng toàn bộ tính năng của dịch vụ"],
    price:
      "Tính cước 6 tin SMS đầu tiên trong ngày giá 500đ/lượt khi nhận bản tin cuộc gọi nhỡ qua SMS",
    action: "ĐĂNG KÝ",
  },
  {
    title: "GÓI MD 3",
    hot: true,
    desc: ["Sử dụng toàn bộ tính năng của dịch vụ"],
    price: "70.000đ/tháng",
    action: "DÙNG NGAY",
  },
  {
    title: "GÓI MVD 10",
    premium: true,
    desc: [
      "Sử dụng toàn bộ tính năng của dịch vụ",
      "10 phút thoại nội mạng và cộng 200 MB data",
    ],
    price: "5.000đ/ngày",
    action: "CHỌN GÓI NÀY",
  },
];

const HomePage = () => {
  return (
    <div className="w-full px-4 lg:px-0 lg:w-4/5 mx-auto py-4">
      <h1 className="font-bold text-base lg:text-[30px] text-[#1F7ED0] mb-6 lg:mt-12 text-center lg:text-left">
        CÁC GÓI CƯỚC MCA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {packages.map((pkg, idx) => {
          if (pkg.type === "image") {
            return (
              <div
                key={idx}
                className="hidden lg:flex items-end justify-center row-span-1"
              >
                <img
                  src={girl}
                  alt="MCA"
                  className="max-h-[329px] object-contain"
                />
              </div>
            );
          }

          const bgClass =
            idx < 2 ? "bg-[#D9D9D9] h-max" : "bg-[#1F7ED0] h-full";
          const borderClass = idx < 2 ? "border-[#1F7ED0]" : "border-[#3CD39C]";
          return (
            <div className={`p-2 ${bgClass} rounded-[10px]`} key={idx}>
              <div
                className={`relative rounded-[10px] border-2 py-4 ${borderClass} h-full shadow-md flex flex-col justify-between bg-white`}
              >
                <div
                  className="relative overflow-hidden
  flex flex-row gap-4 py-2 items-center px-4
  bg-[linear-gradient(89.99deg,_#3CD39C_36.54%,_#1F7ED0_99.99%)]"
                >
                  {/* mảng chéo */}
                  <div
                    className="absolute top-0 right-0 h-full w-10
    bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)]
    [clip-path:polygon(100%_0,_0_0,_100%_100%)]"
                  />

                  <h3 className="text-white text-base lg:text-[22px] font-bold relative z-10">
                    {pkg.title}
                  </h3>

                  <img
                    src={pkg.hot ? hot : pkg.premium ? premium : ""}
                    alt=""
                    className="h-4 relative z-10"
                  />
                </div>

                <div className="px-4 pt-4">
                  <p className="font-semibold mb-1 text-sm">Quyền lợi gói cước:</p>
                  <ul className="text-sm list-disc pl-4 space-y-1">
                    {pkg.desc.map((d, i) => (
                      <li key={i}>{d}</li>
                    ))}
                  </ul>

                  <p className="mt-2 text-sm">
                    <span className="font-semibold text-sm">Giá cước:</span> {pkg.price}
                  </p>
                </div>

                <div className="px-4">
                  <button className="mt-4 w-full mx-auto bg-pink-500 hover:bg-pink-600 text-white font-bold py-2 rounded-full">
                    <Link to="/register">{pkg.action}</Link>
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HomePage;
